export function blocksToMDX(blocks = []) {
  return blocks.map(({ type, data }) => {
    switch (type) {
      case "header":
        return `${"#".repeat(data.level || 2)} ${data.text}`;

      case "paragraph":
        return data.text;

      case "quote":
        return `> ${data.text}`;

      case "list":
        return (data.items || [])
          .map((item) => `- ${typeof item === "string" ? item : item.content || ""}`)
          .join("\n");

      case "code":
        return `\`\`\`${data.language || ""}\n${data.content || ""}\n\`\`\``;

      case "delimiter":
        return `---`;

      case "image":
        const alt = data.alt || data.caption || "Bild";
        const url = data.file?.url || data.url || data.src || "";
        return url ? `![${alt}](${url})` : "";

      case "youtube":
        return data.url ? `<YoutubeEmbed url="${data.url}" />` : "";

      case "gist":
        return data.url ? `<GithubGist url="${data.url}" />` : "";

      case "cta":
        return `<CallToAction>${data.content}</CallToAction>`;

      case "model3d":
        const title = data.title || "";
        const src = data.src || "";
        return `<Model3D title="${title}" src="${src}" />`;

      default:
        return `<!-- Unsupported block: ${type} -->`;
    }
  }).join("\n\n");
}
